import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@utex/ui-kit';
import { Container, Icon, Item as ItemEmotion, ItemProps } from './styles';
import { Info } from './components/Info';
import { Instrument } from '../../hooks/mapInstruments';
import { useWithdrawService } from '../../hooks/useWithdrawService';

export interface Props extends ItemProps {
  icon: string;
  name: string;
  description?: string;
  instrument: Instrument;
}

export const MenuItem: React.FC<Props> = (props) => {
  const { t } = useTranslation('withdraw');
  const withdrawService = useWithdrawService();
  return (
    <Container>
      <ItemEmotion
        {...props}
        onClick={(e) => {
          props.disabled && e.preventDefault();
          withdrawService.reset();
        }}
      >
        <Box display="flex" alignItems="center">
          <Icon src={props.icon} alt={props.name} />

          <Box display="flex" flexDirection="column">
            <Typography.Text size={{ all: 'L', phonablet: 'M' }}>{props.name}</Typography.Text>
            {props.instrument ? (
              <Info {...props.instrument} />
            ) : (
              <Typography.Text size={{ all: 'M', phonablet: 'XS' }} view="hint">
                {props.disabled ? t('In development') : props.description}
              </Typography.Text>
            )}
          </Box>
        </Box>
      </ItemEmotion>
    </Container>
  );
};
